import { defineComponent, ref } from 'vue';
import CarouselListComponent from '@/components/carouselList/CarouselList.vue';
import CarouselFormComponent from '@/components/carouselList/carouselForm/CarouselForm.vue';

export default defineComponent({
  name: 'CarouselPage',
  components: {
    CarouselListComponent,
    CarouselFormComponent
  },
  setup: () => {
    const selectedCarouselId = ref<number | null>();
    const carouselForm = ref<InstanceType<typeof CarouselFormComponent>>();

    const createClick = () => {
      Promise.resolve(selectedCarouselId.value = null)
        .then(() => carouselForm.value?.show());
    };

    const editClick = (carouselId: number) => {
      Promise.resolve(selectedCarouselId.value = carouselId)
        .then(() => carouselForm.value?.show());
    };

    return {
      selectedCarouselId,
      carouselForm,
      createClick,
      editClick,
    };
  },
});
